export const messagesListSelector = state => state.messagesReducer.list;

export const messagesListFetchingSelector = state => state.messagesReducer.listFetching;

export const messagesListPaginationSelector = state => state.messagesReducer.listPagination;

export const singleMessageSelector = state => state.messagesReducer.single;
